export default "__VITE_ASSET__D$RZU080__"